import gql from 'graphql-tag'

export const GET_ROUTE_SHOPS_BY_ID = gql`
    query ($routeId:uuid!){
        RouteShops: RouteShops(where: {routeId: {_eq: $routeId}}){
            id
            organizationId
            lat
            long
            sequence
            Organization{
                id
                name
                mobile
                zone
                Type{
                  id
                  type
                }
            }
        }
    }`

export const GET_ROUTES_BY_ORG_ID = gql`
query($orgId:uuid!) {
    routes: Routes(where: {organizationId: {_eq: $orgId}}){
        id
        name        
    }
}`